<template>
	<section id="single-friend">
		<div class="container-sm is-centered">
			<router-link to="/farewell-rl-friends"><i class="fas fa-chevron-left" aria-hidden></i>Back to all friends</router-link>
			<div class="center-align">
				<img :src="'/img/rl-team-photos/' + person.Photo" :alt="person.Name" :title="person.Name"/>
				<h1>{{person.Name}}</h1>
			</div>
			<template v-if="person.Nickname">
				<h2 v-for="nickname in person.Nickname"><strong>AKA:</strong> {{nickname}}</h2>
			</template>
			<template v-if="person.Catchphrase">				
				<h3>{{person.Name}} can often being heard saying:</h3>
				<blockquote v-for="catchphrase in person.Catchphrase">
					<span class="quote-mark">"</span>{{catchphrase}}<span class="quote-mark">"</span>
				</blockquote>
			</template>
			<div class="memories">
				<h3>A notable memory (or two) that I have about {{person.Name}} is:</h3>
				<p v-html="person.Memories"></p>
			</div>
			<router-link to="/farewell-rl-friends"><i class="fas fa-chevron-left" aria-hidden></i>Back to all friends</router-link>
		</div>
	</section>
</template>

<script>
export default {
	name: 'Friend',
	data() {
		return {
			person: {}
		}
	},
	mounted() {
		const vm = this;
		fetch(process.env.BASE_URL + 'json/rl-friends.json')
		.then(
			function(response) {
				if (response.status !== 200) {
					console.log('Looks like there was a problem. Status Code: ' + response.status);
					return;
				}

				// Examine the text in the response
				response.json().then(function(data) {
					const result = data.filter(person => person.Name === vm.$route.params.id);
					vm.person = result[0];
				});
			}
		)
		.catch(function(err) {
			console.log('Fetch Error :-S', err);
		});
	}
}
</script>

<style lang="scss">
// @import 'src/assets/css/modules/colors';
	#single-friend {
		padding: 6rem 0;
		a {
			display: inline-block;
			font-weight: 500;
			margin: 1rem 0;
			i {
				margin: 0 0.25rem 0 0;
			}
			&:hover, &:focus {
				text-decoration: underline;
			}
		}
		img {
			border-radius: 50%;
			border: 5px solid #434343;
			display: inline-block;
			height: 200px;
			width: 200px;
		}
		h1 {
			font-size: 2.5rem;
			margin: 1rem 0 2.5rem;
		}
		h2 {
			font-weight: normal;
		}
		h3 {
			font-size: 1.125rem;
			font-weight: 500;
			margin: 2rem 0 1rem;
		}
		p {
			line-height: 1.6;
		}
		blockquote {
			background-color: #ebebeb;
			color: #333;
			font-size: 1.25rem;
			font-style: italic;
			margin: 1rem 0;
			padding: 1.5rem;
			.quote-mark {
				color: #000;
				// font-size: 1.5rem;
			}
		}
		.memories {
			margin: 3rem 0 1rem;
		}
	}
</style>